var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "detail-header" }, [
      _c("div", { staticClass: "header-left" }, [
        _c(
          "span",
          {
            staticStyle: {
              "font-size": "16px",
              "font-weight": "bold",
              color: "#333"
            }
          },
          [
            _vm._v(
              _vm._s(_vm.childData.areaName) +
                " " +
                _vm._s(
                  _vm.childData.areaName !== _vm.childData.areaGroupName
                    ? _vm.childData.areaGroupName
                    : ""
                ) +
                " " +
                _vm._s(_vm.childData.garageName) +
                " " +
                _vm._s(_vm.childData.parkingCode)
            )
          ]
        )
      ]),
      _c(
        "div",
        { staticClass: "header-right" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini", plain: "" },
              on: { click: _vm.handleUpdate }
            },
            [_vm._v(_vm._s(_vm.$t("button.edit")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "mini", plain: "" },
              on: { click: _vm.handleDelete }
            },
            [_vm._v(_vm._s(_vm.$t("button.delete")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini", plain: "" },
              on: { click: _vm.changeProprietor }
            },
            [_vm._v("绑定业主")]
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "information" },
      [
        _c(
          "el-col",
          { staticStyle: { "margin-bottom": "10px" }, attrs: { span: 24 } },
          [
            _c("span", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("基础信息")
            ])
          ]
        ),
        _c(
          "el-form",
          {
            ref: "dataForm",
            attrs: { "label-position": "right", "label-width": "130px" }
          },
          [
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.parkingCode") } },
                  [_c("span", [_vm._v(_vm._s(_vm.childData.parkingCode))])]
                )
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.leaseControl") } },
                  [_c("span", [_vm._v(_vm._s(_vm.childData.isLeaseName))])]
                )
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.parkingType") } },
                  [_c("span", [_vm._v(_vm._s(_vm.childData.parkingTypeName))])]
                )
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.parkingArea") } },
                  [_c("span", [_vm._v(_vm._s(_vm.childData.parkingArea))])]
                )
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.carNumberOne") } },
                  [_c("span", [_vm._v(_vm._s(_vm.childData.carNumberOne))])]
                )
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.carNumberTwo") } },
                  [_c("span", [_vm._v(_vm._s(_vm.childData.carNumberTwo))])]
                )
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.customInfo") } },
                  [_c("span", [_vm._v(_vm._s(_vm.childData.customerName))])]
                )
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("table.saleDate") } },
                  [_c("span", [_vm._v(_vm._s(_vm.childData.saleDate))])]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }